export default "__VITE_ASSET__de539ad9__"